import React, { useState, useEffect } from "react";
import MainBody from "../../../component/MainBody";
import httpRequest from "../../../utils/Http";
import { Link } from "react-router-dom";
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import "../../../asset/css/excelcss.css";
import { toast } from "react-toastify";
import MyDataTable from "../../../component/MyDataTable";
import { openSignUrl } from "../../../utils/HelperFunction";

const UploadPartBom = () => {
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [rows, setRows] = useState(null);
  const [cols, setcols] = useState(null);
  const [isSubmit, setSubmit] = useState(false);
  const [reloadList, setReload] = useState(true);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    if (!value.file) {
      errors.part_file = "Part File is Required (Only xlsx & xls file)";
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        document.getElementById("uploadpartbom").reset();
        const data = await httpRequest(
          "processuploadbom",
          formData,
          "POST",
          "multipart/form-data"
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          setFormData({});
          setRows(null);
          setcols(null);
          setReload(true);
        } else {
          toast.error(data.message);
        }
        setSubmit(false);
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const columns = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
    },
    {
      name: "File Name",
      selector: (row) => row.file_name,
      cell: (row) => (
        <Link
          to={"javascript:void(0)"}
          className="btn-link text-primary"
          onClick={() => openSignUrl(row.file_path)}
        >
          {row.file_name}
        </Link>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Response",
      selector: (row) => <div className="word-wrap">{row.response}</div>,
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
  ];

  return (
    <div>
      <MainBody
        breadcrumbTitle="Upload Part BOM"
        breadcrumbSubTitle={""}
        navButton={""}
        title={""}
        component={
          <>
            <section className="content">
              <div className="container-fluid">
                <form
                  id="uploadpartbom"
                  onSubmit={onSubmitHandler}
                  encType="multipart/form-data"
                >
                  <div className="card card-default">
                    <div className="card-header">
                      <h3 className="card-title">Upload Part BOM</h3>
                      <span className="float-right">
                        <Link
                          to={"javascript:void(0)"}
                          className="btn-link text-primary"
                          onClick={() =>
                            openSignUrl("samplefolder/partbom.xlsx")
                          }
                        >
                          Download Sample File
                        </Link>
                      </span>
                    </div>
                    <div className="card-body">
                      <div className="row">
                    
                        <div className="col-md-4">
                          {/* /.form-group */}
                          <div className="form-group">
                            <label>
                              Upload BOM File *{" "}
                              <span style={{ color: "red" }}>
                                {formErrors.part_file}
                              </span>
                            </label>
                            <input
                              name="file"
                              type="file"
                              className="form-control"
                              accept=".xlsx, .xls"
                              onChange={(e) => {
                                var files = e.target.files;
                                if (files && files[0]) {
                                  var file_name = e.target.files[0]["name"];
                                  const regex = new RegExp("(.*?)(xlsx|xls)$");
                                  if (!regex.test(file_name.toLowerCase())) {
                                    setFormErrors({
                                      part_file:
                                        "Part File is Required (Only xlsx & xls file)",
                                    });
                                  } else {
                                    setRows(null);
                                    setcols(null);
                                    ExcelRenderer(
                                      e.target.files[0],
                                      (err, resp) => {
                                        //handle fail case here
                                        if (err) {
                                          // console.log(err);
                                        }
                                        //handle success case here
                                        else {
                                          //  console.log(resp.cols);
                                          setRows(resp.rows);
                                          setcols(resp.cols);
                                        }
                                      }
                                    );
                                    setFormData({
                                      ...formData,
                                      file: e.target.files[0],
                                    });
                                  }
                                } else {
                                  setFormErrors({
                                    model: "Only xlsx & xls file allow",
                                  });
                                }
                              }}
                            />
                          </div>

                          {/* /.form-group */}
                        </div>
                        <div className="col-md-4">
                          {/* /.form-group */}
                            <div className="form-group">
                                <label>
                                .{" "}
                                
                                </label>
                                <input
                            type="submit"
                            className="form-control btn btn-primary"
                            value={"Submit"}
                          />
                            </div>
                        </div>
                        {/* /.col */}
                      </div>
                      <div className="row">
                        <div className={rows && "col-md-12 restrict-card"}>
                          {rows && (
                            <OutTable
                              data={rows}
                              columns={cols}
                              tableClassName="table table-bordered table-striped dataTable dtr-inline"
                              tableHeaderRowClass="heading"
                            />
                          )}
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </form>
              </div>
            </section>

            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">File Upload History</h3>
                      </div>

                      <MyDataTable
                        reloadList={reloadList}
                        columns={columns}
                        getDataListURL={
                          "getfileuploadhistory?type=BOM_EXCEL"
                        }
                        setReload={setReload}
                        exportName={"fileuploadlist"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            
          </>
        }
      />
    </div>
  );
};

export default UploadPartBom;
